import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1ee276ef&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=1ee276ef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee276ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee276ef')) {
      api.createRecord('1ee276ef', component.options)
    } else {
      api.reload('1ee276ef', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=1ee276ef&scoped=true", function () {
      api.rerender('1ee276ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/Modal.vue"
export default component.exports